export const link = ({ theme: { colors } }) => {
    const activeStyle = {
        color: colors.primary,
        textDecoration: 'underline',
    };

    return {
        fontSize: '14px',
        lineHeight: 1.21,
        letterSpacing: '0.5px',
        background: 'none',
        border: 'none',
        color: colors.text, // override <a> tag
        textDecoration: 'underline',
        '-webkit-appearance': 'none',
        fontWeight: 700,

        '&:hover': activeStyle,
        '&:focus': activeStyle,
        '&:active': activeStyle,
    };
};
